import type { StepPanelsPassThroughOptions } from "primevue/steppanels";

export const steppanels: StepPanelsPassThroughOptions = {
  root: "px-2 pt-4 pb-[1.125rem]"
};
